<template>
    <div class="flex items-center justify-end space-x-4">
        <ui-button-new small icon="fa fa-undo"
                       @click="undo"
                       @mousedown="disableStateTracking"
                       :disabled="undosAvailable()?false:true"
        >Undo {{ undosAvailable() ? '(' + undosAvailable() + ')' : '' }}
        </ui-button-new>
        <ui-button-new small icon="fa fa-repeat"
                       @click="redo"
                       @mousedown="disableStateTracking"
                       :disabled="redosAvailable()?false:true"
        >Redo {{ redosAvailable() ? '(' + redosAvailable() + ')' : '' }}
        </ui-button-new>
        <div class="flex">
            <ui-dropdown placement="bottom-end" menu-class="p-3 w-72">
                <template #default="{ toggle }">
                    <!--
                    <ui-button-new @click="toggle" small primary>
                        Actions
                        <i class="flex-shrink-0 ml-2 fa fa-chevron-down"></i>
                    </ui-button-new>
                    -->
                </template>

                <template #menu="{ close }">
                    <!--
                    <ui-dropdown-item icon="fa fa-file-plus" @click="close();">Create a Revision</ui-dropdown-item>
                    <ui-dropdown-divider></ui-dropdown-divider>
                    <ui-dropdown-item icon="fa fa-eye">Preview</ui-dropdown-item>
                    <ui-dropdown-item icon="fa fa-arrow-down" :href="inspectionTestPlan._links.download" target="_blank">Download</ui-dropdown-item>
                    <ui-dropdown-item icon="fa fa-arrow-down" :href="inspectionTestPlan._links.download_no_rates" target="_blank">Download (No Rate)</ui-dropdown-item>
                    <ui-dropdown-item icon="fa fa-arrow-down" :href="inspectionTestPlan._links.download_no_costs" target="_blank">Download (No Costs)</ui-dropdown-item>
                    <ui-dropdown-divider></ui-dropdown-divider>
                    <ui-dropdown-item icon="fas fa-clone" @click="close();">Copy To...</ui-dropdown-item>
                    <ui-dropdown-item icon="fas fa-computer-classic" @click="">Copy To Classic Quote</ui-dropdown-item>
                    <ui-dropdown-divider></ui-dropdown-divider>
                    -->
                    <ui-dropdown-item danger icon="fa fa-trash" @click="deleteInspectionTestPlan">Delete</ui-dropdown-item>
                </template>
            </ui-dropdown>
        </div>
    </div>
</template>

<script>
import {InspectionTestPlan} from "../../models";

export default {
    props: {
        inspectionTestPlan: Object,
    },
    data() {
        return {
            states: [],
            position: 0,
            selectedPage: []
        }
    },
    methods: {
        deleteInspectionTestPlan() {
            this.$modals.confirmDelete({
                title: `Delete Inspection Test Plan #${this.inspectionTestPlan.reference}`,
                button: 'Yes, delete the inspection test plan',
                handle: async () => {
                    await this.inspectionTestPlan.delete()
                    window.location = route('mobile.packages.inspection-test-plans', this.inspectionTestPlan.package_id)
                }
            })
        },
        undosAvailable() {
            return this.states.length - this.redosAvailable() - 1
        },
        redosAvailable() {
            return this.states.length - this.position - 1
        },
        disableStateTracking() {
            this.inspectionTestPlan.disableSnapshots = true;
            document.activeElement.blur();
        },
        undo() {
            Object.assign(this.inspectionTestPlan, JSON.parse(this.states[--this.position]))
            this.inspectionTestPlan.update();
            this.inspectionTestPlan.disableSnapshots = false;
        },
        redo() {
            Object.assign(this.inspectionTestPlan, JSON.parse(this.states[++this.position]))
            this.inspectionTestPlan.update();
            this.inspectionTestPlan.disableSnapshots = false;
        }
    },
    mounted() {
        this.inspectionTestPlan.clearSnapshots(0);
        this.inspectionTestPlan.addSnapshot();
        this.states = this.inspectionTestPlan.getSnapshotStore().states;
        this.position = this.states.length - 1;

        eventBus.$on('inspection-test-plan-history-state-updated', (data) => {
            if (data.inspectionTestPlan === this.inspectionTestPlan) {
                if (this.position + 1 !== data.states.length - 1) {
                    this.inspectionTestPlan.clearSnapshots(this.position + 1, data.states.length - this.position - 2);
                    data = this.inspectionTestPlan.getSnapshotStore();
                }
                this.states = data.states
                this.position = data.states.length - 1;
                this.$forceUpdate();
            }
        });
    }
}
</script>
